/**
 * @generated SignedSource<<672861edb3a467c47872f4baad3d71aa>>
 * @relayHash a681ca4341eb62abd94f1e002744692a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8f19dca02a8c6c08d36848966e224cc2b9ece80fd54f2c467d2e7b7657bc7699

import type { ConcreteRequest } from 'relay-runtime';
export type MoveToPersonalSpaceFlagTriggerMoveBlogMutation$variables = {
  blogPostId: AGG$Long;
  spaceId: AGG$Long;
};
export type MoveToPersonalSpaceFlagTriggerMoveBlogMutation$data = {
  readonly moveBlog: {
    readonly content: {
      readonly id: string | null;
      readonly space: {
        readonly alias: string | null;
        readonly key: string | null;
      } | null;
    } | null;
  } | null;
};
export type MoveToPersonalSpaceFlagTriggerMoveBlogMutation = {
  response: MoveToPersonalSpaceFlagTriggerMoveBlogMutation$data;
  variables: MoveToPersonalSpaceFlagTriggerMoveBlogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "blogPostId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "blogPostId",
        "variableName": "blogPostId"
      },
      {
        "kind": "Variable",
        "name": "targetSpaceId",
        "variableName": "spaceId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "key"
},
v4 = {
  "kind": "ScalarField",
  "name": "alias"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MoveToPersonalSpaceFlagTriggerMoveBlogMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "MoveBlogPayload",
        "kind": "LinkedField",
        "name": "moveBlog",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoveToPersonalSpaceFlagTriggerMoveBlogMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "MoveBlogPayload",
        "kind": "LinkedField",
        "name": "moveBlog",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a681ca4341eb62abd94f1e002744692a",
    "id": "8f19dca02a8c6c08d36848966e224cc2b9ece80fd54f2c467d2e7b7657bc7699",
    "metadata": {},
    "name": "MoveToPersonalSpaceFlagTriggerMoveBlogMutation",
    "operationKind": "mutation",
    "text": "mutation MoveToPersonalSpaceFlagTriggerMoveBlogMutation($blogPostId:Long!,$spaceId:Long!){moveBlog(input:{blogPostId:$blogPostId,targetSpaceId:$spaceId}){content{id,space{key,alias,id}}}}"
  }
};
})();

(node as any).hash = "93b9a44f4c2595f8a579191b1566d4aa";

export default node;
